import { modifier } from 'ember-modifier';

const horizontalScroll = (element: HTMLElement, [scrollAmount = 60]) => {
	// Horizontal scrolling - supported for mouse scroll down and up
	// https://jsfiddle.net/q3pf2hge

	const wheelCheckFn = (event: WheelEvent) => {
		// checking scroll direction (deltaY for horizontal, deltaX for vertical scrolling)
		const isForward =
			(!event.deltaX && event.deltaY > 0) || (!event.deltaY && event.deltaX > 0);

		const isBackwards =
			(!event.deltaX && event.deltaY < 0) || (!event.deltaY && event.deltaX < 0);

		if (!isForward && !isBackwards) {
			return;
		}

		// const isForward = (event.deltaY || event.deltaX) > 0;

		let position = element.scrollLeft;
		position += isForward ? scrollAmount : -scrollAmount;

		element.scrollLeft = position;
		event.preventDefault();
	};

	element.addEventListener('wheel', wheelCheckFn);

	return () => {
		element.removeEventListener('wheel', wheelCheckFn);
	};
};

const horizontalScrollModifier = modifier(horizontalScroll);

export default horizontalScrollModifier;
